import { columnSettings, tableWidth } from "./report-template-setting";
import { format } from "date-fns";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateDetail = (props) => {
  const {
    mykey,
    no,
    sales_number,
    customer_name,
    customer_code,
    quantity,
    bc_name,
    expired_date,
    transaction_date,
    price,
  } = props;

  const numberFormat = (number) => {
    // not currency
    return new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  const priceFormat = (number) => {
    // currency
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  return (
    <tr
      key={mykey}
      className={`row-start-start ${tableWidth} text-sm text-slate-700 !items-stretch`}
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
      >
        {no}
      </td>

      <td
        className={`${settings["sales_number"].layout} ${settings["sales_number"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {sales_number ? sales_number : "-"}
      </td>

      <td
        className={`${settings["transaction_date"].layout} ${settings["transaction_date"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {transaction_date ? format(new Date(transaction_date), settings["transaction_date"].format) : "-"}
      </td>

      <td
        className={`${settings["bc_name"].layout} ${settings["bc_name"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {bc_name ? bc_name : "-"}
      </td>

      <td
        className={`${settings["customer_code"].layout} ${settings["customer_code"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {customer_code ? customer_code : "-"}
      </td>

      <td
        className={`${settings["customer_name"].layout} ${settings["customer_name"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {customer_name ? customer_name : "-"}
      </td>

      <td
        className={`${settings["quantity"].layout} ${settings["quantity"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {numberFormat(quantity)}
      </td>

      {/* <td
        className={`${settings["price"].layout} ${settings["price"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {priceFormat(price)}
      </td> */}

      <td
        className={`${settings["expired_date"].layout} ${settings["expired_date"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {expired_date ? format(new Date(expired_date), settings["expired_date"].format) : "-"}
      </td>

      {/*
      <td
        className={`${settings["transaction_date"].layout} ${settings["transaction_date"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1`}
      >
        {transaction_date
          ? format(
            new Date(transaction_date),
            settings["transaction_date"].format
          )
          : "-"}
      </td> */}

      {/* <td
        className={`${settings["product_name"].layout} ${settings["product_name"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        <span className="text-xs">{product_name}</span>
      </td> */}
    </tr>
  );
};

export default ReportTemplateDetail;
